<template>
  <div class="cell">
    {{ value }}
  </div>
</template>

<script>
export default {
  props: {
    // 親コンポーネントからString,Numberのどちらとも受け取りうる
    value: { type: [String, Number] },
  },
  data() {
    return {
      input: this.value,
    };
  },
};
</script>

<style lang="scss" scoped>
.cell {
  padding-left: 0px !important;
  padding-right: 0px !important;
}
</style>
